<template>
  <svg
    @click="$emit('click',$event)"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0703 0.0996094H2.92969C1.31439 0.0996094 0 1.414 0 3.0293V17.1699C0 18.7852 1.31439 20.0996 2.92969 20.0996H8.82812V13.0293H6.48438V9.51367H8.82812V7.13086C8.82812 5.19223 10.4051 3.61523 12.3438 3.61523H15.8984V7.13086H12.3438V9.51367H15.8984L15.3125 13.0293H12.3438V20.0996H17.0703C18.6856 20.0996 20 18.7852 20 17.1699V3.0293C20 1.414 18.6856 0.0996094 17.0703 0.0996094Z"
      fill="white"
    />
  </svg>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
svg {
    cursor:pointer;
}
</style>